import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { styles } from '../../styles.js';

export const navLinks = [
    {
        id: 'about',
        title: 'About',
    },
    {
        id: 'projects',
        title: 'Projects',
    },
    {
        id: 'career',
        title: 'Career',
    },
    {
        id: 'skills',
        title: 'Skills',
    },
    {
        id: 'contact',
        title: 'Contact',
    },
];

const NavBar = () => {
    const [active, setActive] = useState("");
    const [toggle, setToggle] = useState(false);

    const constructLink = (link) => (
        <li
            key={link.id}
            className={`${active === link.title ? "text-white" : "text-secondary"} hover:text-white text-[24px] font-bold cursor-pointer select-none`}
            onClick={() => setActive(link.title)}
        >
            <a href={`#${link.id}`}>{link.title}</a>
        </li>
    );

    return (
        <nav className={`${styles.paddingX} w-full flex items-center py-5 fixed top-0 z-20 bg-primary`}>
            <div className="w-full flex justify-between items-center max-w-7x1 mx-auto">
                <Link
                    to="/"
                    className="flex items-center gap-2"
                    onClick={() => {
                        setActive("");
                        window.scrollTo(0, 0);
                    }}
                >
                    <img src="./Icon.png" alt="Ricardo Matos Icon" className="w-18 h-9 object-contain" />
                    
                </Link>
                <ul className="list-none hidden sm:flex flex-row gap-10 text-primary-400" >
                    {navLinks.map((link) => constructLink(link))}
                </ul>
                <div className="sm:hidden flex justify-end items-center w-full">
                    <button
                        className="text-white"
                        onClick={() => setToggle(!toggle)}
                    >
                        {toggle ? 'Close' : 'Menu'}
                    </button>
                </div>
            </div>

            {toggle && (
                <div className="sm:hidden flex flex-col items-center w-full bg-primary absolute top-14 left-0">
                    <ul className="list-none flex flex-col gap-4 py-4 text-primary-400" >
                        {navLinks.map((link) => constructLink(link))}
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default NavBar;
